var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _path13, _g12, _path14, _g13, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertoTres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 132,
    viewBox: "0 0 120 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 114,
    width: 10,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6431 114.989C61.3874 116.285 64.0784 120.944 64.2215 121.187C62.9405 121.931 61.5091 122.296 60.0777 122.296C58.6463 122.296 57.2149 121.924 55.9338 121.187C56.077 120.944 58.768 116.285 59.5123 114.989C59.6841 115.089 59.8773 115.14 60.0777 115.14C60.2781 115.14 60.4642 115.089 60.6431 114.989Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 114.99C61.3876 116.286 64.0786 120.945 64.2218 121.188C62.9407 121.932 61.5093 122.297 60.0779 122.297C58.6465 122.297 57.2152 121.925 55.9341 121.188C56.0772 120.945 58.7682 116.286 59.5125 114.99C59.6843 115.09 59.8775 115.141 60.0779 115.141C60.2783 115.141 60.4644 115.09 60.6433 114.99Z",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 114.99C59.6843 115.09 59.8775 115.141 60.0779 115.141C60.2783 115.141 60.4644 115.09 60.6433 114.99C61.3519 116.221 63.8138 120.48 64.1788 121.117C64.1431 121.159 64.1001 121.21 64.0643 121.253L63.9928 121.317C62.7689 121.968 61.4234 122.297 60.0779 122.297C58.6465 122.297 57.2152 121.925 55.9341 121.188C56.0772 120.945 58.7682 116.286 59.5125 114.99Z",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 114.99C59.6843 115.09 59.8775 115.141 60.0779 115.141C60.2783 115.141 60.4644 115.09 60.6433 114.99C61.2517 116.049 63.1626 119.349 63.914 120.659C63.8854 120.716 63.8496 120.802 63.821 120.859C63.6993 121.074 63.4775 121.474 63.0194 121.761C62.0747 122.119 61.0799 122.297 60.0779 122.297C58.6465 122.297 57.2152 121.925 55.9341 121.188C56.0772 120.945 58.7682 116.286 59.5125 114.99Z",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5126 114.99C59.6844 115.09 59.8776 115.141 60.078 115.141C60.2784 115.141 60.4645 115.09 60.6434 114.99C61.173 115.913 62.6974 118.554 63.5777 120.079C63.2843 121.038 62.6617 121.789 61.8959 122.097C61.2947 122.233 60.6864 122.297 60.0709 122.297C58.6395 122.297 57.2081 121.925 55.927 121.188C56.0701 120.945 58.7611 116.286 59.5055 114.99",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 114.99C59.6843 115.09 59.8775 115.141 60.0779 115.141C60.2783 115.141 60.4644 115.09 60.6433 114.99C61.1157 115.799 62.3467 117.939 63.2341 119.485C63.2198 119.535 63.1984 119.606 63.1912 119.657C62.8548 120.988 61.7598 122.097 60.5861 122.29C60.4143 122.297 60.2497 122.305 60.0779 122.305C58.6465 122.305 57.2152 121.932 55.9341 121.195C56.0772 120.952 58.7682 116.293 59.5125 114.997",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 114.99C59.6843 115.09 59.8775 115.141 60.0779 115.141C60.2783 115.141 60.4644 115.09 60.6433 114.99C61.0584 115.706 62.0604 117.445 62.9049 118.905C62.8906 118.969 62.8691 119.048 62.8548 119.113C62.454 120.966 60.7578 122.333 58.9901 122.226C57.9309 122.083 56.886 121.739 55.9341 121.188C56.0772 120.945 58.7682 116.286 59.5125 114.99Z",
    fill: "#D14C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5126 114.99C59.6844 115.09 59.8776 115.141 60.078 115.141C60.2784 115.141 60.4645 115.09 60.6434 114.99C61.0084 115.613 61.8243 117.03 62.5829 118.354C62.5686 118.411 62.5543 118.49 62.5471 118.547C62.1464 120.837 59.713 122.677 56.8717 121.66C56.5497 121.525 56.2347 121.367 55.927 121.195C56.0701 120.952 58.7611 116.293 59.5055 114.997",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5127 114.99C59.6845 115.09 59.8777 115.141 60.0781 115.141C60.2785 115.141 60.4646 115.09 60.6435 114.99C60.9584 115.534 61.6168 116.679 62.2896 117.839C62.2896 117.867 62.2824 117.903 62.2753 117.925C61.8387 120.802 58.7469 122.333 56.0344 121.016C56.5569 120.115 58.8399 116.164 59.5127 114.99Z",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5127 114.991C59.6844 115.091 59.8777 115.141 60.0781 115.141C60.2785 115.141 60.4645 115.091 60.6435 114.991C60.9154 115.463 61.4379 116.372 62.0104 117.352C62.0104 117.402 61.9961 117.467 61.989 117.517C61.6096 119.886 59.0833 121.718 56.2634 120.609C57.0364 119.27 58.9115 116.028 59.5127 114.983",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5127 114.99C59.6845 115.09 59.8777 115.141 60.0781 115.141C60.2785 115.141 60.4646 115.09 60.6435 114.99C60.8725 115.384 61.2804 116.1 61.7456 116.901C61.7456 116.944 61.7313 117.001 61.7242 117.044C61.3377 119.506 58.9759 120.902 56.5569 120.093C57.4372 118.576 58.9688 115.913 59.5055 114.99",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5127 114.99C59.6844 115.09 59.8777 115.141 60.0781 115.141C60.2785 115.141 60.4645 115.09 60.6435 114.99C60.8295 115.312 61.1373 115.849 61.5023 116.472C61.5023 116.508 61.488 116.558 61.488 116.601C61.1516 118.819 59.0546 120.158 56.9004 119.513C57.795 117.975 59.0403 115.813 59.5127 114.99Z",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5127 114.99C59.6844 115.09 59.8776 115.141 60.078 115.141C60.2784 115.141 60.4645 115.09 60.6434 114.99C60.7866 115.241 61.0084 115.62 61.2661 116.064C61.2661 116.092 61.2589 116.135 61.2518 116.171C60.9655 118.161 59.2192 119.349 57.2654 118.876C58.1027 117.424 59.0976 115.699 59.5127 114.99Z",
    fill: "#C0452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 114.99C59.6843 115.09 59.8775 115.141 60.0779 115.141C60.2783 115.141 60.4644 115.09 60.6433 114.99C60.7435 115.162 60.8795 115.391 61.0369 115.67C61.0369 115.699 61.0298 115.727 61.0226 115.756C60.8866 116.429 60.7506 117.13 59.8489 117.781C58.9829 118.411 58.0239 118.254 57.666 118.189C58.4032 116.915 59.169 115.591 59.5125 114.99Z",
    fill: "#BD442A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5126 114.99C59.6844 115.09 59.8776 115.141 60.078 115.141C60.2784 115.141 60.4645 115.09 60.6434 114.99C60.6864 115.069 60.7436 115.162 60.8009 115.262C60.8009 115.277 60.7937 115.305 60.7866 115.319C60.6291 116.057 60.5361 116.465 59.8705 116.987C59.2693 117.459 58.5965 117.438 58.1099 117.416C58.6896 116.407 59.2335 115.47 59.5126 114.99Z",
    fill: "#BA432A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 88,
    width: 50,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5674C107.163 89.8628 109.861 94.5219 109.997 94.7653L64.2215 121.196C64.0784 120.952 61.3874 116.293 60.6431 114.998L106.419 88.5745V88.5674Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6431 114.991L106.419 88.5674C106.462 88.6461 106.519 88.7391 106.576 88.8393L60.8005 115.263C60.7433 115.162 60.686 115.069 60.6431 114.991Z",
    fill: "#BA432A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8005 115.262L106.576 88.8389C106.648 88.9605 106.726 89.0965 106.812 89.2397L61.0367 115.67C60.9508 115.52 60.8721 115.384 60.8005 115.269",
    fill: "#BD442A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0369 115.671L106.812 89.2402C106.884 89.3691 106.963 89.4979 107.042 89.641L61.2659 116.072C61.1872 115.928 61.1084 115.8 61.0369 115.671Z",
    fill: "#C0452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2659 116.071L107.042 89.6406C107.12 89.7694 107.199 89.9054 107.278 90.0486L61.502 116.479C61.4233 116.336 61.3446 116.2 61.2659 116.071Z",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.502 116.479L107.278 90.0488C107.356 90.1848 107.442 90.3279 107.521 90.4782L61.7453 116.909C61.6594 116.766 61.5807 116.622 61.502 116.479Z",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7454 116.909L107.521 90.4785C107.607 90.6288 107.693 90.7791 107.779 90.9294L62.003 117.36C61.9171 117.21 61.8241 117.059 61.7454 116.909Z",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.01 117.359L107.786 90.9287C107.879 91.0862 107.972 91.2508 108.065 91.4082L62.2891 117.839C62.1961 117.674 62.103 117.517 62.01 117.359Z",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2893 117.839L108.065 91.4082C108.165 91.58 108.265 91.7517 108.358 91.9235L62.5827 118.354C62.4825 118.182 62.3823 118.01 62.2893 117.839Z",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5828 118.354L108.358 91.9238C108.466 92.1099 108.573 92.2888 108.673 92.4677L62.8977 118.898C62.7975 118.719 62.6901 118.533 62.5828 118.354Z",
    fill: "#D14C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8975 118.898L108.673 92.4678C108.788 92.6682 108.902 92.8614 109.009 93.0546L63.2338 119.485C63.1265 119.299 63.012 119.106 62.8975 118.898Z",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2341 119.485L109.01 93.0547C109.131 93.2694 109.246 93.4698 109.353 93.6487L63.5777 120.079C63.4703 119.893 63.3558 119.693 63.2341 119.478",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5847 120.079L109.36 93.6484C109.489 93.8631 109.597 94.0635 109.697 94.2281L63.9211 120.659C63.8281 120.494 63.7135 120.301 63.5847 120.079Z",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9138 120.659L109.689 94.2285C109.811 94.4361 109.897 94.5935 109.954 94.6794L64.1786 121.11C64.1285 121.017 64.0355 120.867 63.9138 120.659Z",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1785 121.11L109.954 94.6797L109.997 94.7584L64.2214 121.189L64.1785 121.11Z",
    fill: "#E05132"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 88,
    width: 50,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 114.99C58.7682 116.285 56.0701 120.945 55.9341 121.188L10.1584 94.7575C10.3016 94.5141 12.9926 89.855 13.7369 88.5596L59.5197 114.99H59.5125Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7299 88.5596L59.5127 114.99C59.2336 115.47 58.6896 116.407 58.1099 117.416L12.3271 90.9858C12.9069 89.9766 13.4508 89.0391 13.7299 88.5596Z",
    fill: "#BA432A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3341 90.9854L58.1169 117.416C57.9666 117.673 57.8163 117.931 57.666 118.189L11.8904 91.7583C12.0407 91.5007 12.191 91.2358 12.3413 90.9854",
    fill: "#BD442A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8834 91.7666L57.659 118.197C57.523 118.426 57.3942 118.655 57.2654 118.884L11.4897 92.4537C11.6186 92.2318 11.7546 92.0028 11.8834 91.7666Z",
    fill: "#C0452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4898 92.4453L57.2654 118.876C57.1366 119.098 57.0149 119.305 56.9004 119.513L11.1248 93.0823C11.2393 92.8819 11.3681 92.6672 11.4898 92.4453Z",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1247 93.083L56.9003 119.514C56.7787 119.721 56.6642 119.921 56.564 120.1L10.7883 93.6699C10.8957 93.491 11.003 93.2906 11.1247 93.083Z",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7811 93.6699L56.5567 120.1C56.4493 120.294 56.342 120.465 56.2561 120.616L10.4805 94.1852C10.5664 94.0349 10.6665 93.8632 10.7811 93.6699Z",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4878 94.1855L56.2634 120.616C56.1704 120.781 56.0917 120.917 56.0344 121.017L10.2588 94.5863C10.316 94.4861 10.3948 94.3502 10.4878 94.1855Z",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2516 94.5859L56.0272 121.016C55.9771 121.109 55.9413 121.167 55.927 121.188L10.1514 94.7577L10.2516 94.5859Z",
    fill: "#CE4A2E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 87,
    width: 9,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.992 87.5794C108.487 87.5794 113.862 87.5794 114.148 87.5794C114.148 90.5424 112.567 93.2763 109.997 94.7578C109.854 94.5145 107.163 89.8553 106.419 88.5599C106.777 88.3524 106.992 87.9802 106.992 87.5723V87.5794Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.992 87.5794C108.487 87.5794 113.862 87.5794 114.148 87.5794C114.148 90.5424 112.567 93.2763 109.997 94.7578C109.854 94.5145 107.163 89.8553 106.419 88.5599C106.777 88.3524 106.992 87.9802 106.992 87.5723",
    fill: "#F65937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C108.208 87.5791 111.994 87.5791 113.519 87.5791C114.027 87.7723 114.048 87.7795 114.148 87.8296C114.063 90.6924 112.495 93.3189 110.005 94.7646C109.861 94.5213 107.17 89.8622 106.426 88.5668",
    fill: "#F65937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.872 87.5791 110.105 87.5791 111.844 87.5791C113.69 88.5381 113.934 88.8029 114.041 88.9174C113.64 91.3508 112.173 93.505 110.005 94.7575C109.861 94.5141 107.17 89.855 106.426 88.5596",
    fill: "#F45836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.707 87.5791 109.317 87.5791 110.828 87.5791C112.087 88.2948 113.519 89.3182 113.819 89.8979C113.225 91.9233 111.88 93.6768 110.005 94.7646C109.861 94.5213 107.17 89.8622 106.426 88.5668",
    fill: "#F15736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.593 87.5791 108.831 87.5791 110.105 87.5791C112.116 88.8459 113.333 90.1556 113.497 90.7997C112.803 92.4386 111.593 93.8414 109.997 94.7646C109.854 94.5213 107.163 89.8622 106.419 88.5668Z",
    fill: "#EE5635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.5 87.5791 108.466 87.5791 109.532 87.5791C111.622 88.9246 113.082 90.7926 113.096 91.6299C112.381 92.911 111.321 94.006 110.005 94.7646C109.861 94.5213 107.17 89.8622 106.426 88.5668",
    fill: "#EB5535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.428 87.5791 108.187 87.5791 109.06 87.5791C111.558 89.218 112.846 91.6872 112.603 92.4029C111.923 93.3547 111.042 94.1635 110.005 94.7646C109.861 94.5213 107.17 89.8622 106.426 88.5668",
    fill: "#E85434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.357 87.5791 107.965 87.5791 108.666 87.5791C111.329 89.3826 112.452 92.2884 112.03 93.1114C111.45 93.7555 110.77 94.3138 109.997 94.7575C109.854 94.5141 107.163 89.855 106.419 88.5596",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.299 87.5791 107.772 87.5791 108.33 87.5791C111.193 89.5974 112.023 92.8466 111.372 93.7698C110.956 94.142 110.498 94.4784 109.997 94.7646C109.854 94.5213 107.163 89.8622 106.419 88.5668Z",
    fill: "#E25233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.242 87.5791 107.607 87.5791 108.044 87.5791C110.856 89.6331 111.615 93.1543 110.627 94.3639C110.427 94.507 110.219 94.6358 110.005 94.7646C109.861 94.5213 107.17 89.8622 106.426 88.5668",
    fill: "#E05132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.192 87.5791 107.464 87.5791 107.779 87.5791C110.548 89.6117 111.078 93.3333 109.954 94.6859C109.568 94.0203 107.127 89.7906 106.419 88.5668Z",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.142 87.5791 107.335 87.5791 107.557 87.5791C109.625 89.1107 110.584 92.0951 109.69 94.2279C108.931 92.9182 107.027 89.6188 106.419 88.5668Z",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.099 87.5791 107.221 87.5791 107.356 87.5791C109.425 89.1823 109.926 91.8446 109.36 93.6482C108.48 92.1237 106.956 89.49 106.426 88.5668",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791C107.049 87.5791 107.113 87.5791 107.178 87.5791C108.774 88.8602 109.475 90.9572 109.01 93.0541C108.122 91.5154 106.884 89.3755 106.419 88.5668Z",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.777 88.3592 106.992 87.987 106.992 87.5791H107.027C107.836 88.2733 109.124 89.8264 108.681 92.4744C107.836 91.0216 106.834 89.2824 106.419 88.5668Z",
    fill: "#D14C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.748 88.3736 106.956 88.0372 106.984 87.665C106.992 87.6722 107.006 87.6865 107.02 87.6937C108.151 88.7815 108.616 90.2415 108.358 91.9162C107.593 90.5994 106.777 89.1823 106.419 88.5597",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5675C106.712 88.3958 106.913 88.1095 106.97 87.7803C106.977 87.7946 106.992 87.8089 107.006 87.8161C108.251 89.1902 108.158 90.7862 108.058 91.4088C107.392 90.2494 106.727 89.1115 106.412 88.5675",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5676C106.684 88.4173 106.87 88.1668 106.949 87.8877C106.956 87.902 106.97 87.9163 106.984 87.9306C107.829 89.0185 107.886 90.1636 107.786 90.9294C107.221 89.9489 106.691 89.0328 106.419 88.5676Z",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5667C106.648 88.4307 106.82 88.2303 106.913 87.9941C106.92 88.0085 106.934 88.0228 106.941 88.0371C107.543 88.9675 107.578 89.7619 107.521 90.4704C107.056 89.6689 106.648 88.9532 106.419 88.5595",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5668C106.612 88.4523 106.762 88.2948 106.863 88.1016C106.863 88.1159 106.877 88.1302 106.884 88.1373C107.213 88.7743 107.328 89.3039 107.278 90.0482C106.92 89.4256 106.605 88.8888 106.419 88.5668Z",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5675C106.576 88.4744 106.705 88.3599 106.798 88.2168C106.798 88.2168 106.798 88.224 106.798 88.2311C106.941 88.589 107.07 88.9969 107.035 89.6482C106.777 89.1973 106.555 88.8251 106.412 88.5746",
    fill: "#C0452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.5672C106.526 88.5028 106.627 88.4241 106.705 88.3311C106.705 88.3454 106.712 88.3668 106.72 88.3812C106.784 88.6674 106.82 88.8965 106.813 89.2471C106.655 88.9752 106.519 88.7462 106.419 88.5672Z",
    fill: "#BD442A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 88.567C106.469 88.5384 106.519 88.5026 106.569 88.4668C106.569 88.4668 106.569 88.474 106.569 88.4811C106.569 88.6028 106.576 88.7244 106.576 88.8461C106.519 88.7459 106.462 88.6529 106.419 88.5742",
    fill: "#BA432A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 87,
    width: 8,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7297 88.5596C12.9854 89.855 10.2944 94.5141 10.1513 94.7575C7.58908 93.276 6.00024 90.5349 6.00024 87.5791C6.28652 87.5791 11.6614 87.5791 13.1572 87.5791C13.1572 87.987 13.3719 88.3592 13.7297 88.5596Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7297 88.5596C12.9854 89.855 10.2944 94.5141 10.1513 94.7575C7.58908 93.276 6.00024 90.5349 6.00024 87.5791C6.28652 87.5791 11.6614 87.5791 13.1572 87.5791C13.1572 87.987 13.3719 88.3592 13.7297 88.5596Z",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1642 87.5791C13.1642 87.987 13.379 88.3592 13.7368 88.5596C12.9925 89.855 10.3015 94.5141 10.1583 94.7575C8.15441 93.5981 6.75165 91.6729 6.2292 89.4757C6.21488 89.4041 6.20057 89.3111 6.19341 89.2395C6.129 88.4308 6.16479 88.2089 6.28645 87.5791C7.45303 87.5791 11.8402 87.5791 13.1714 87.5791",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1644 87.5791C13.1644 87.987 13.3791 88.3592 13.737 88.5596C13.0571 89.7333 10.7812 93.6768 10.2587 94.5857C10.1442 94.5285 9.99392 94.4569 9.88657 94.4068C6.93792 92.6891 6.0934 89.6761 6.78763 87.5791C8.39077 87.5791 11.9907 87.5791 13.1716 87.5791",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1643 87.5791C13.1643 87.987 13.379 88.3592 13.7369 88.5596C13.1357 89.6045 11.2606 92.8466 10.4948 94.1849C10.4733 94.1778 10.4447 94.1635 10.4232 94.1563C8.13299 93.1615 6.29366 90.5134 7.39582 87.5791C9.17074 87.5791 12.1265 87.5791 13.1715 87.5791",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1644 87.5791C13.1644 87.987 13.3791 88.3592 13.7369 88.5596C13.2001 89.49 11.6686 92.1452 10.7883 93.6696C10.6881 93.6267 10.5521 93.5766 10.4447 93.5408C8.05432 92.3814 7.03088 89.8192 8.05432 87.5791C9.82923 87.5791 12.2411 87.5791 13.1644 87.5791Z",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1644 87.5794C13.1644 87.9874 13.3791 88.3595 13.737 88.5599C13.2646 89.3758 12.0193 91.5372 11.1247 93.0831C11.0317 93.0473 10.9028 93.0044 10.8098 92.9686C8.34781 91.8521 7.82535 89.3472 8.7486 87.5723C10.409 87.5723 12.3557 87.5723 13.1644 87.5723",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1644 87.5791C13.1644 87.987 13.3791 88.3592 13.737 88.5596C13.329 89.2681 12.3342 90.9929 11.4897 92.4458C11.4038 92.4172 11.2965 92.3814 11.2106 92.3528C9.2138 91.5011 8.46232 89.4471 9.46429 87.5791C10.9386 87.5791 12.4702 87.5791 13.1644 87.5791Z",
    fill: "#C0452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1642 87.5794C13.1642 87.9874 13.3789 88.3595 13.7368 88.5599C13.3933 89.1611 12.6203 90.4851 11.8903 91.7591C9.9651 91.1436 9.2494 89.3472 10.2084 87.5723C11.4323 87.5723 12.5917 87.5723 13.1642 87.5723",
    fill: "#BD442A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1644 87.5791C13.1644 87.987 13.3791 88.3592 13.7369 88.5596C13.4578 89.0391 12.9139 89.9838 12.3342 90.9858C12.2769 90.9643 12.1982 90.9429 12.1338 90.9214C11.2034 90.5993 10.8455 89.9051 10.7239 89.5258C10.4376 88.6598 10.8097 87.9799 11.0316 87.5791C11.9334 87.5791 12.7206 87.5791 13.1715 87.5791",
    fill: "#BA432A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 34,
    width: 8,
    height: 54
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1642 87.5787C11.6684 87.5787 6.2936 87.5787 6.00732 87.5787V34.7178C6.2936 34.7178 11.6684 34.7178 13.1642 34.7178V87.5716V87.5787Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1643 34.7178V87.5716C12.7206 87.5716 11.9262 87.5716 11.0244 87.5716V34.7178C11.9262 34.7178 12.7206 34.7178 13.1643 34.7178Z",
    fill: "#BA432A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0171 34.7178V87.5716C10.7523 87.5716 10.4803 87.5716 10.2012 87.5716V34.7178C10.4803 34.7178 10.7523 34.7178 11.0171 34.7178Z",
    fill: "#BD442A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2084 34.7178V87.5716C9.95794 87.5716 9.7146 87.5716 9.46411 87.5716V34.7178C9.7146 34.7178 9.9651 34.7178 10.2084 34.7178Z",
    fill: "#C0452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46423 34.7178V87.5716C9.22089 87.5716 8.98471 87.5716 8.74854 87.5716V34.7178C8.98471 34.7178 9.22089 34.7178 9.46423 34.7178Z",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74842 34.7178V87.5716C8.51224 87.5716 8.27606 87.5716 8.0542 87.5716V34.7178C8.27606 34.7178 8.51224 34.7178 8.74842 34.7178Z",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05426 34.7178V87.5716C7.81809 87.5716 7.59622 87.5716 7.38867 87.5716V34.7178C7.59622 34.7178 7.81809 34.7178 8.05426 34.7178Z",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38861 34.7178V87.5716C7.16675 87.5716 6.9592 87.5716 6.78027 87.5716V34.7178C6.9592 34.7178 7.16675 34.7178 7.38861 34.7178Z",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78028 34.7178V87.5716C6.57989 87.5716 6.40812 87.5716 6.2793 87.5716V34.7178C6.40812 34.7178 6.57989 34.7178 6.78028 34.7178Z",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27929 34.7178V87.5716C6.12899 87.5716 6.03595 87.5716 6.00732 87.5716V34.7178C6.00732 34.7178 6.13615 34.7178 6.27929 34.7178Z",
    fill: "#D14C2F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 34,
    width: 9,
    height: 54
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.991 34.7178C108.487 34.7178 113.862 34.7178 114.148 34.7178V87.5716C113.862 87.5716 108.487 87.5716 106.991 87.5716V34.7178Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.991 87.5787V34.7178H107.027V87.5716H106.991",
    fill: "#D14C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.027 87.5787V34.7178C107.077 34.7178 107.128 34.7178 107.178 34.7178V87.5716C107.12 87.5716 107.07 87.5716 107.027 87.5716",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.177 87.5787V34.7178C107.235 34.7178 107.292 34.7178 107.356 34.7178V87.5716C107.292 87.5716 107.235 87.5716 107.177 87.5716",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.356 87.5787V34.7178C107.421 34.7178 107.485 34.7178 107.557 34.7178V87.5716C107.485 87.5716 107.421 87.5716 107.356 87.5716",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.55 87.5787V34.7178C107.621 34.7178 107.7 34.7178 107.779 34.7178V87.5716C107.7 87.5716 107.621 87.5716 107.55 87.5716",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.779 87.5787V34.7178C107.865 34.7178 107.951 34.7178 108.036 34.7178V87.5716C107.951 87.5716 107.865 87.5716 107.779 87.5716",
    fill: "#E05132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.036 87.5787V34.7178C108.129 34.7178 108.23 34.7178 108.33 34.7178V87.5716C108.23 87.5716 108.137 87.5716 108.036 87.5716",
    fill: "#E25233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33 87.5787V34.7178C108.437 34.7178 108.552 34.7178 108.666 34.7178V87.5716C108.552 87.5716 108.437 87.5716 108.33 87.5716",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.666 87.5787V34.7178C108.795 34.7178 108.924 34.7178 109.06 34.7178V87.5716C108.924 87.5716 108.795 87.5716 108.666 87.5716",
    fill: "#E85434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.06 87.5787V34.7178C109.21 34.7178 109.368 34.7178 109.525 34.7178V87.5716C109.368 87.5716 109.21 87.5716 109.06 87.5716",
    fill: "#EB5535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.525 87.5787V34.7178C109.711 34.7178 109.904 34.7178 110.09 34.7178V87.5716C109.897 87.5716 109.711 87.5716 109.525 87.5716",
    fill: "#EE5635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.098 87.5787V34.7178C110.341 34.7178 110.591 34.7178 110.835 34.7178V87.5716C110.591 87.5716 110.341 87.5716 110.098 87.5716",
    fill: "#F15736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.835 87.5787V34.7178C111.178 34.7178 111.515 34.7178 111.837 34.7178V87.5716C111.515 87.5716 111.178 87.5716 110.835 87.5716",
    fill: "#F45836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.837 87.5787V34.7178C112.502 34.7178 113.096 34.7178 113.519 34.7178V87.5716C113.096 87.5716 112.502 87.5716 111.837 87.5716",
    fill: "#F65937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.519 87.5787V34.7178C113.862 34.7178 114.091 34.7178 114.141 34.7178V87.5716C114.091 87.5716 113.862 87.5716 113.519 87.5716",
    fill: "#F95A38"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 27,
    width: 9,
    height: 8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.419 33.7379C107.163 32.4425 109.854 27.7834 109.997 27.54C112.56 29.0215 114.148 31.7626 114.148 34.7256C113.862 34.7256 108.487 34.7256 106.992 34.7256C106.992 34.3176 106.777 33.9455 106.419 33.7451V33.7379Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.419 33.7379C107.163 32.4425 109.854 27.7834 109.997 27.54C112.56 29.0215 114.148 31.7626 114.148 34.7256C113.862 34.7256 108.487 34.7256 106.992 34.7256C106.992 34.3176 106.777 33.9455 106.419 33.7451",
    fill: "#FC5B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7187C106.992 34.3107 106.777 33.9386 106.419 33.7382C106.92 32.8794 108.28 30.5176 109.174 28.9717C109.174 29.0862 109.182 29.2436 109.189 29.3582C109.146 33.1298 113.333 32.5 113.676 32.2066C113.698 32.1923 113.719 32.1637 113.733 32.1422C114.005 32.9652 114.148 33.8312 114.148 34.7187C113.862 34.7187 108.487 34.7187 106.992 34.7187Z",
    fill: "#FC5B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7189C106.992 34.3109 106.777 33.9388 106.419 33.7384C106.784 33.1014 107.621 31.6557 108.394 30.3174C108.409 30.3746 108.423 30.4534 108.437 30.5106C108.774 31.6486 108.902 32.0708 109.79 32.579C110.413 32.9368 112.989 33.7312 114.084 33.7169C114.127 34.0461 114.148 34.3825 114.148 34.726C113.862 34.726 108.487 34.726 106.992 34.726",
    fill: "#F95A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7187C106.992 34.3108 106.777 33.9386 106.419 33.7382C106.72 33.2229 107.328 32.1637 107.965 31.0615C107.986 31.1402 108.022 31.2404 108.051 31.3192C108.523 32.6504 108.638 32.9653 113.519 34.7187C111.994 34.7187 108.208 34.7187 106.992 34.7187Z",
    fill: "#F65937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7177C106.992 34.3098 106.777 33.9376 106.419 33.7373C106.669 33.3078 107.135 32.4991 107.65 31.6045C107.65 31.6045 107.65 31.6116 107.65 31.6188C107.979 32.3679 108.287 32.8498 108.573 33.0645C108.712 33.1647 109.215 33.4295 110.083 33.8589C110.67 34.1452 111.257 34.4243 111.837 34.7249C110.098 34.7249 107.865 34.7249 106.984 34.7249",
    fill: "#F45836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.718C106.992 34.3101 106.777 33.9379 106.419 33.7375C106.626 33.3725 106.991 32.7427 107.414 32.0127C107.435 32.0628 107.471 32.1344 107.492 32.1845C107.664 32.6067 107.793 32.9359 108.23 33.2652C109.024 33.8735 109.962 34.2242 110.82 34.718C109.31 34.718 107.7 34.718 106.984 34.718",
    fill: "#F15736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7192C106.992 34.3113 106.777 33.9391 106.419 33.7387C106.598 33.431 106.884 32.9371 107.221 32.3574C107.492 32.9061 107.702 33.2425 107.85 33.3665C108.537 33.9319 109.36 34.2612 110.105 34.7264C108.831 34.7264 107.593 34.7264 106.992 34.7264",
    fill: "#EE5635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7184C106.992 34.3105 106.777 33.9383 106.419 33.7379C106.569 33.4803 106.791 33.0938 107.056 32.6357C107.07 32.6644 107.085 32.7002 107.099 32.7288C107.328 33.1868 107.399 33.3443 107.7 33.5876C108.258 34.0457 108.924 34.3248 109.518 34.7184C108.459 34.7184 107.492 34.7184 106.984 34.7184",
    fill: "#EB5535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7182C106.992 34.3103 106.777 33.9381 106.419 33.7377C106.541 33.5302 106.712 33.2296 106.92 32.8789C106.934 32.9147 106.956 32.9576 106.977 32.9934C107.099 33.2725 107.235 33.5087 107.5 33.7234C107.979 34.1242 108.552 34.3747 109.06 34.7254C108.187 34.7254 107.428 34.7254 106.992 34.7254",
    fill: "#E85434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7187C106.992 34.3107 106.777 33.9386 106.419 33.7382C106.512 33.5736 106.641 33.3517 106.798 33.0869C106.813 33.1155 106.834 33.1585 106.848 33.1871C106.999 33.502 107.092 33.6452 107.314 33.8384C107.729 34.1891 108.222 34.4181 108.666 34.7258C107.965 34.7258 107.357 34.7258 106.992 34.7258",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7182C106.992 34.3102 106.777 33.9381 106.419 33.7377C106.491 33.6088 106.584 33.4514 106.691 33.2725C106.691 33.2796 106.698 33.2868 106.705 33.2939C106.891 33.6446 106.941 33.7448 107.156 33.9309C107.514 34.2458 107.951 34.4462 108.33 34.7253C107.772 34.7253 107.299 34.7253 106.992 34.7253",
    fill: "#E25233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7189C106.992 34.311 106.777 33.9388 106.419 33.7384C106.469 33.6525 106.526 33.5452 106.598 33.4307C106.612 33.4521 106.626 33.4879 106.641 33.5094C106.712 33.6454 106.805 33.8386 107.013 34.0175C107.328 34.2895 107.707 34.4684 108.036 34.7261C107.607 34.7261 107.242 34.7261 106.992 34.7261",
    fill: "#E05132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.7183C106.992 34.3104 106.777 33.9382 106.419 33.7379C106.448 33.6878 106.483 33.6305 106.512 33.5732C106.526 33.5947 106.541 33.6233 106.548 33.6377C106.612 33.7593 106.705 33.9311 106.884 34.0885C107.156 34.3319 107.492 34.4893 107.772 34.7183C107.457 34.7183 107.185 34.7183 106.984 34.7183",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.991 34.7188C106.991 34.547 106.956 34.3824 106.884 34.2393C106.898 34.2464 106.913 34.2607 106.92 34.2679C107.127 34.4253 107.342 34.5613 107.55 34.7188C107.328 34.7188 107.142 34.7188 106.991 34.7188Z",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.991 34.7186C106.991 34.6184 106.977 34.5182 106.948 34.418C106.948 34.418 106.963 34.4251 106.963 34.4323C107.092 34.5253 107.228 34.6184 107.349 34.7186C107.213 34.7186 107.092 34.7186 106.984 34.7186",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.992 34.718C106.992 34.6679 106.992 34.6106 106.984 34.5605C106.999 34.5677 107.02 34.582 107.027 34.5963C107.07 34.6321 107.135 34.6822 107.178 34.718C107.113 34.718 107.049 34.718 106.992 34.718Z",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.419 33.7373L106.448 33.6943C106.448 33.6943 106.469 33.7373 106.483 33.7587L106.505 33.7945C106.505 33.7945 106.455 33.7587 106.426 33.7444",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.991 34.7181C106.991 34.7181 106.991 34.6966 106.991 34.6895C106.999 34.6966 107.013 34.7109 107.027 34.7181C107.013 34.7181 107.006 34.7181 106.991 34.7181Z",
    fill: "#D14C2F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 27,
    width: 8,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1642 34.7178C11.6684 34.7178 6.2936 34.7178 6.00732 34.7178C6.00732 31.7548 7.589 29.0137 10.1583 27.5322C10.3015 27.7756 12.9925 32.4347 13.7368 33.7301C13.3789 33.9377 13.1642 34.3098 13.1642 34.7178Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1642 34.7178C11.6684 34.7178 6.2936 34.7178 6.00732 34.7178C6.00732 31.7548 7.589 29.0137 10.1583 27.5322C10.3015 27.7756 12.9925 32.4347 13.7368 33.7301C13.3789 33.9377 13.1642 34.3098 13.1642 34.7178Z",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7369C13.3789 33.9444 13.1642 34.3166 13.1642 34.7245C11.6684 34.7245 6.2936 34.7245 6.00732 34.7245C6.00732 31.8761 7.47449 29.2352 9.8649 27.7179C9.97941 27.7036 10.1369 27.7036 10.2514 27.7108C10.7667 28.5982 13.0569 32.5631 13.7368 33.7369Z",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7371C13.3789 33.9447 13.1642 34.3168 13.1642 34.7248C11.6684 34.7248 6.2936 34.7248 6.00732 34.7248C6.00732 32.1912 7.16674 29.8151 9.11343 28.2549C9.69314 28.0903 10.1297 28.2048 10.6378 28.3694C11.4824 29.8223 13.1714 32.7495 13.7368 33.7371Z",
    fill: "#E25233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7373C13.3789 33.9448 13.1642 34.317 13.1642 34.7249C11.6684 34.7249 6.2936 34.7249 6.00732 34.7249C6.00732 32.5134 6.88763 30.4308 8.39773 28.8992C9.34245 28.3982 10.6164 28.9135 11.0386 29.0781C11.9333 30.624 13.243 32.8928 13.7296 33.7373",
    fill: "#E05132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7372C13.3789 33.9447 13.1642 34.3169 13.1642 34.7248C11.6684 34.7248 6.2936 34.7248 6.00732 34.7248C6.00732 32.8569 6.63713 31.0819 7.7393 29.6506C8.63391 29.0279 9.87922 29.0565 11.4251 29.7364C12.2768 31.2108 13.3145 33.0072 13.7368 33.7372Z",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7369C13.3789 33.9445 13.1642 34.3166 13.1642 34.7246C11.6684 34.7246 6.2936 34.7246 6.00732 34.7246C6.00732 33.2288 6.40811 31.7902 7.13812 30.5449C8.08283 29.5358 9.97941 29.4428 11.7615 30.3302C12.5344 31.6686 13.3718 33.1143 13.7368 33.7441",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7374C13.3789 33.9449 13.1642 34.3171 13.1642 34.725C11.6684 34.725 6.2936 34.725 6.00732 34.725C6.00732 33.63 6.22203 32.5708 6.62282 31.5903C7.25978 30.5525 9.23509 29.4933 12.0692 30.846C12.7491 32.0197 13.4219 33.1863 13.7368 33.7374Z",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7366C13.3789 33.9442 13.1642 34.3163 13.1642 34.7243C11.6684 34.7243 6.2936 34.7243 6.00732 34.7243C6.00732 34.0873 6.07889 33.4647 6.22203 32.8563C6.96635 31.0027 9.46411 29.922 12.334 31.3176C12.9137 32.3267 13.4577 33.2643 13.7368 33.7438",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.737C13.3789 33.9445 13.1642 34.3167 13.1642 34.7246C11.6684 34.7246 6.2936 34.7246 6.00732 34.7246C6.00732 34.6316 6.00732 34.5314 6.00732 34.4384C6.35086 31.9191 9.35676 30.1514 12.5702 31.7402C13.0569 32.5847 13.4935 33.3362 13.7296 33.7441",
    fill: "#D14C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7371C13.379 33.9446 13.1643 34.3168 13.1643 34.7247C11.8402 34.7247 7.44587 34.7247 6.2793 34.7247C7.17391 31.547 10.3587 30.8958 12.7921 32.1124C13.1857 32.7995 13.5293 33.3935 13.7296 33.7371",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7373C13.3789 33.9448 13.1642 34.317 13.1642 34.7249C11.9834 34.7249 8.38342 34.7249 6.78027 34.7249C7.89675 31.8908 10.8168 31.3469 12.9925 32.4562C13.3002 32.993 13.565 33.451 13.7368 33.7373Z",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7369 33.7372C13.379 33.9447 13.1643 34.3169 13.1643 34.7248C12.1194 34.7248 9.16359 34.7248 7.38867 34.7248C8.61966 32.1412 11.2892 31.7905 13.1786 32.771C13.4076 33.1718 13.608 33.5081 13.7369 33.7372Z",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7374C13.3789 33.9449 13.1642 34.3171 13.1642 34.725C12.241 34.725 9.82911 34.725 8.0542 34.725C9.27087 32.4777 11.6899 32.1915 13.3432 33.0574C13.5006 33.3294 13.6366 33.5656 13.7368 33.7374Z",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7369 33.7373C13.3791 33.9448 13.1644 34.317 13.1644 34.7249C12.3556 34.7249 10.4089 34.7249 8.74854 34.7249C9.99384 32.6995 12.0837 32.5779 13.4936 33.3222C13.5866 33.4796 13.6653 33.6228 13.7297 33.7373",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7368 33.7373C13.3789 33.9449 13.1642 34.317 13.1642 34.725C12.47 34.725 10.9384 34.725 9.46411 34.725C10.6092 33.0359 12.3841 32.9286 13.6366 33.5656C13.6724 33.63 13.7082 33.6872 13.7368 33.7373Z",
    fill: "#C0452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1643 34.7184C12.5846 34.7184 11.4252 34.7184 10.2085 34.7184C11.0459 33.559 12.3842 33.1868 13.7082 33.7522C13.3719 33.9597 13.1715 34.3247 13.1715 34.7184",
    fill: "#BD442A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1643 34.7178C12.7206 34.7178 11.9262 34.7178 11.0244 34.7178C11.461 34.2025 12.191 33.5583 13.5436 33.8661C13.3003 34.0808 13.1572 34.3886 13.1572 34.7178",
    fill: "#BA432A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 1,
    width: 50,
    height: 33
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7369 33.7378C12.9926 32.4423 10.2944 27.7832 10.1584 27.5399L55.9341 1.10938C56.0772 1.35271 58.7682 6.01186 59.5125 7.30726L13.7369 33.7306V33.7378Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 7.30719L13.7368 33.7377C13.7082 33.6876 13.6724 33.6303 13.6438 33.5731L59.4123 7.14258C59.4481 7.19983 59.4767 7.25709 59.5053 7.30719",
    fill: "#C0452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4124 7.14275L13.6368 33.5661C13.5938 33.4945 13.5438 33.4086 13.4937 33.3227L59.2764 6.89941C59.3265 6.9853 59.3766 7.07118 59.4196 7.14275",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2765 6.89859L13.5009 33.3291C13.4508 33.2432 13.4007 33.1573 13.3506 33.0643L59.1191 6.63379C59.1763 6.72683 59.2264 6.81271 59.2694 6.89859",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.119 6.63491L13.3433 33.0654C13.2932 32.9724 13.236 32.8793 13.1787 32.7791L58.9543 6.34863C59.0116 6.44883 59.0689 6.54903 59.119 6.63491Z",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9543 6.34811L13.1787 32.7714C13.1214 32.6712 13.057 32.5639 12.9998 32.4565L58.7682 6.0332C58.8326 6.14056 58.8899 6.24791 58.9472 6.34811",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7683 6.03299L12.9926 32.4563C12.9282 32.3418 12.8638 32.2273 12.7922 32.1128L58.575 5.68945C58.6466 5.80396 58.711 5.92563 58.7754 6.03299",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5751 5.68986L12.7995 32.1132C12.7279 31.9915 12.6564 31.8627 12.5776 31.7339L58.3533 5.31055C58.4248 5.43937 58.5036 5.5682 58.5751 5.68986Z",
    fill: "#D14C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3532 5.31093L12.5776 31.7343C12.4988 31.5983 12.4201 31.4551 12.3342 31.312L58.1099 4.88867C58.1886 5.03181 58.2745 5.16779 58.3532 5.31093Z",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1098 4.88805L12.3342 31.3114C12.2483 31.1539 12.1553 31.0036 12.0623 30.8462L57.8379 4.42285C57.9309 4.5803 58.0168 4.73776 58.1098 4.88805Z",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8379 4.42285L12.0623 30.8462C11.9621 30.6744 11.8619 30.4955 11.7617 30.3237L57.5373 3.90039C57.6375 4.07216 57.7377 4.25108 57.8379 4.42285Z",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5374 3.90066L11.7617 30.324C11.6472 30.1236 11.5327 29.9304 11.4182 29.7371L57.201 3.30664C57.3084 3.49988 57.4229 3.69311 57.5374 3.89351",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2008 3.30655L11.4252 29.737C11.2964 29.508 11.1676 29.2933 11.0459 29.0858L56.8215 2.65527C56.9432 2.86282 57.0649 3.08469 57.2008 3.30655Z",
    fill: "#E05132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8216 2.65514L11.046 29.0856C10.8957 28.8208 10.7525 28.5847 10.6309 28.3699L56.4137 1.93945C56.5353 2.147 56.6713 2.39034 56.8288 2.65514",
    fill: "#E25233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4136 1.93969L10.6309 28.3702C10.4662 28.0839 10.3303 27.8549 10.2444 27.7046L56.0272 1.28125C56.1131 1.42439 56.2419 1.66057 56.4136 1.94684",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0272 1.28114L10.2516 27.7045L10.1514 27.5327L55.9342 1.10938L56.0344 1.28114",
    fill: "#E85434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 1,
    width: 50,
    height: 33
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6434 7.30726C61.3877 6.01186 64.0859 1.35271 64.2218 1.10938L109.997 27.5399C109.854 27.7832 107.163 32.4423 106.419 33.7378L60.6362 7.30726H60.6434Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.419 33.7374L60.6433 7.30693L60.6719 7.25684L106.455 33.6873L106.426 33.7374",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.448 33.6876L60.6648 7.26425C60.6863 7.22846 60.7077 7.18552 60.7364 7.14258L106.519 33.5731C106.498 33.616 106.469 33.659 106.448 33.6947",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.519 33.5658L60.7366 7.13533C60.7652 7.09238 60.7867 7.04229 60.8153 6.99219L106.598 33.4227C106.569 33.4728 106.541 33.5229 106.519 33.5658Z",
    fill: "#E05132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.598 33.4297L60.8223 6.99925C60.8509 6.94915 60.8795 6.89905 60.9153 6.8418L106.698 33.2723C106.669 33.3295 106.634 33.3796 106.605 33.4297",
    fill: "#E25233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.691 33.2728L60.9082 6.84233C60.944 6.78507 60.9798 6.72066 61.0156 6.65625L106.798 33.0867C106.763 33.1511 106.727 33.2156 106.691 33.2728Z",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.798 33.0863L61.0154 6.65579C61.0512 6.59138 61.0941 6.51981 61.137 6.44824L106.92 32.8787C106.877 32.9503 106.841 33.0219 106.798 33.0863Z",
    fill: "#E85434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.92 32.8717L61.1372 6.44126C61.1801 6.36253 61.2302 6.2838 61.2732 6.20508L107.056 32.6356C107.006 32.7143 106.963 32.8002 106.92 32.8717Z",
    fill: "#EB5535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.056 32.6357L61.2803 6.20522C61.3304 6.11218 61.3876 6.01914 61.4449 5.91895L107.228 32.3494C107.17 32.4496 107.113 32.5427 107.063 32.6357",
    fill: "#EE5635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.221 32.3489L61.4451 5.91841C61.5095 5.81105 61.5739 5.69654 61.6383 5.58203L107.421 32.0125C107.357 32.127 107.292 32.2415 107.228 32.3489",
    fill: "#F15736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.421 32.0054L61.6382 5.58209C61.7169 5.44611 61.7956 5.31013 61.8744 5.16699L107.657 31.5975C107.578 31.7406 107.493 31.8766 107.421 32.0126",
    fill: "#F45836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.657 31.5903L61.8813 5.16699C61.9815 4.99522 62.0817 4.8163 62.1819 4.64453L107.965 31.075C107.865 31.2539 107.764 31.4257 107.664 31.5975",
    fill: "#F65937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.958 31.0677L62.1821 4.63722C62.3253 4.38673 62.4756 4.13623 62.6187 3.88574L108.394 30.3162C108.251 30.5667 108.101 30.8172 107.958 31.0677Z",
    fill: "#F95A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.394 30.316L62.6187 3.88553C62.8978 3.39886 63.1697 2.9265 63.4131 2.51855L109.189 28.949C108.953 29.3641 108.681 29.8293 108.401 30.316",
    fill: "#FC5B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.189 28.9498L63.4058 2.51929C63.8495 1.7535 64.1716 1.19526 64.2216 1.10938L109.997 27.5399C109.947 27.6186 109.625 28.184 109.181 28.9498",
    fill: "#FF5C39"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15723C60.2783 7.15723 60.4644 7.20733 60.6433 7.30752C75.9018 16.1177 91.1675 24.9278 106.426 33.738C106.777 33.9456 106.999 34.3177 106.999 34.7185V87.5723C106.999 87.9803 106.784 88.3524 106.426 88.56C91.1675 97.3701 75.909 106.18 60.6504 114.983C60.4715 115.084 60.2783 115.134 60.085 115.134C59.8846 115.134 59.6986 115.084 59.5196 114.983C44.2539 106.173 28.9954 97.363 13.7369 88.5528C13.3862 88.3453 13.1643 87.9731 13.1643 87.5723V34.7185C13.1643 34.3106 13.379 33.9384 13.7369 33.7309C28.9954 24.9207 44.2539 16.1105 59.5125 7.30752C59.6914 7.20733 59.8846 7.15723 60.0779 7.15723Z",
    fill: "#EC5535"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 0,
    width: 6,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 7.30721C58.7682 6.01181 56.0772 1.35266 55.9341 1.10932C57.2152 0.365003 58.6465 0 60.0779 0V7.15692C59.8775 7.15692 59.6915 7.20701 59.5125 7.30721Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 7.30721C58.7682 6.01181 56.0772 1.35266 55.9341 1.10932C57.2152 0.365003 58.6465 0 60.0779 0V7.15692C59.8775 7.15692 59.6915 7.20701 59.5125 7.30721Z",
    fill: "#F15736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15728C59.8775 7.15728 59.6915 7.20738 59.5125 7.30757C58.7682 6.01217 56.0772 1.35302 55.9341 1.10968C56.9217 0.53713 58.0024 0.186442 59.1046 0.0576172C59.1332 0.0790879 59.1618 0.100559 59.1905 0.122029C59.5483 0.479875 59.8704 1.09537 60.0779 1.50331V7.16443",
    fill: "#F15736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15673C59.8775 7.15673 59.6915 7.20683 59.5125 7.30703C58.7682 6.01162 56.0772 1.35247 55.9341 1.10914C56.6426 0.701193 57.3941 0.407759 58.167 0.22168C58.1957 0.235994 58.2386 0.250307 58.2672 0.264621C58.8183 0.629624 59.4123 1.40257 60.0851 2.6264V7.15673",
    fill: "#EE5635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15657C59.8775 7.15657 59.6915 7.20667 59.5125 7.30687C58.7682 6.01147 56.0772 1.35231 55.9341 1.10898C56.3707 0.858488 56.8215 0.650937 57.2796 0.486328C58.0311 0.64378 59.1261 1.81036 60.0779 3.46361V7.16373",
    fill: "#EB5535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15647C59.8775 7.15647 59.6915 7.20657 59.5125 7.30677C58.7682 6.01136 56.0772 1.35221 55.9341 1.10888C56.0987 1.00868 56.2705 0.922797 56.4422 0.836914C56.4565 0.836914 56.478 0.836914 56.4995 0.836914C57.9666 1.02299 59.6342 3.30605 60.0779 4.11478V7.15647Z",
    fill: "#E85434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.1574C59.8775 7.1574 59.6914 7.2075 59.5125 7.30769C58.8326 6.1268 56.5424 2.16187 56.0271 1.27441C56.0343 1.27441 56.0486 1.27441 56.0557 1.27441C57.8593 1.56069 59.6557 3.87953 60.0708 4.64532V7.14309",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15684C59.8775 7.15684 59.6914 7.20694 59.5125 7.30714C58.9471 6.32664 57.2509 3.39231 56.4136 1.93945C56.4851 1.96808 56.5782 1.99671 56.6498 2.02534C58.1813 2.64799 59.5841 4.20104 60.0851 5.10997V7.15684",
    fill: "#E25233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15729C59.8775 7.15729 59.6915 7.20739 59.5125 7.30759C59.0259 6.46307 57.7161 4.19433 56.8215 2.64844C56.8931 2.67707 56.979 2.72001 57.0506 2.74863C58.8613 3.67903 59.7702 4.97443 60.0779 5.48973V7.15014",
    fill: "#E05132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.078 7.15706C59.8776 7.15706 59.6915 7.20716 59.5126 7.30736C59.0904 6.57735 58.0526 4.78097 57.2009 3.30664C57.2653 3.33527 57.3512 3.37821 57.4156 3.40684C58.5965 4.05812 59.4911 4.874 60.078 5.83303V7.15706Z",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.078 7.15711C59.8776 7.15711 59.6915 7.20721 59.5126 7.3074C59.1476 6.67044 58.3102 5.2319 57.5444 3.89355C57.5874 3.91503 57.6446 3.94365 57.6876 3.96512C58.2315 4.22277 59.348 4.97425 60.078 6.12651V7.15711Z",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15711C59.8775 7.15711 59.6915 7.20721 59.5125 7.30741C59.1976 6.75633 58.5249 5.58975 57.845 4.41602C57.8951 4.44464 57.9666 4.47327 58.0167 4.5019C58.4104 4.72376 59.3264 5.24622 60.0779 6.38417V7.14996",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15676C59.8775 7.15676 59.6915 7.20686 59.5125 7.30705C59.2334 6.82754 58.6967 5.88998 58.1169 4.88086C59.1976 5.42478 59.8131 6.20489 60.0851 6.61999V7.1496",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0778 7.15735C59.8774 7.15735 59.6914 7.20745 59.5124 7.30765C59.2763 6.8997 58.8397 6.14823 58.353 5.30371C58.396 5.32518 58.4532 5.35381 58.4962 5.37528C59.0115 5.68303 59.5554 6.0695 60.0778 6.82813V7.15735Z",
    fill: "#D14C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15694C59.8775 7.15694 59.6914 7.20704 59.5125 7.30724C59.3121 6.95655 58.9686 6.36968 58.575 5.68262C58.6107 5.70409 58.6608 5.72556 58.6966 5.74703C59.2978 6.10487 59.67 6.44841 60.0779 7.00665V7.14978",
    fill: "#CE4A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5126 7.30746C59.3479 7.02118 59.0831 6.56314 58.7754 6.02637C58.8112 6.04784 58.8541 6.06931 58.8827 6.08362C59.4338 6.42 59.7201 6.70627 60.0708 7.15C59.8776 7.15 59.6915 7.2001 59.5126 7.3003",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5126 7.307C59.3766 7.07798 59.1834 6.74161 58.9543 6.34082C58.983 6.35513 59.0188 6.3766 59.0474 6.39808C59.4124 6.61994 59.6414 6.81318 59.9492 7.16387C59.7989 7.17818 59.6486 7.22828 59.5054 7.307",
    fill: "#C9482D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 7.30654C59.4123 7.13477 59.2763 6.90575 59.1189 6.63379C59.1404 6.6481 59.1762 6.66957 59.1976 6.68389C59.441 6.83418 59.6127 6.96301 59.8346 7.18487C59.7201 7.20634 59.6056 7.24928 59.5054 7.3137",
    fill: "#C6472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 7.30736C59.4481 7.19285 59.3694 7.05687 59.2764 6.89941C59.2978 6.91373 59.3265 6.92804 59.3479 6.94236C59.4624 7.01392 59.5483 7.06402 59.7344 7.21432C59.6628 7.23579 59.5841 7.27157 59.5125 7.31452",
    fill: "#C3462C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5125 7.30719C59.4839 7.25709 59.4481 7.19983 59.4124 7.14258C59.4267 7.14974 59.4553 7.16405 59.4696 7.17836C59.5197 7.20699 59.5626 7.23562 59.6056 7.25709C59.5698 7.2714 59.5412 7.29287 59.5054 7.30719",
    fill: "#C0452B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3191_33573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0,
    width: 5,
    height: 8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15692V0C61.5093 0 62.9406 0.37216 64.2217 1.10932C64.0786 1.35266 61.3876 6.01181 60.6433 7.30721C60.4715 7.20701 60.2783 7.15692 60.0779 7.15692Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15692V0C61.5093 0 62.9406 0.37216 64.2217 1.10932C64.0786 1.35266 61.3876 6.01181 60.6433 7.30721C60.4715 7.20701 60.2783 7.15692 60.0779 7.15692Z",
    fill: "#FC5B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30721C60.4715 7.20701 60.2783 7.15692 60.0779 7.15692V0C61.4019 0 62.7188 0.314904 63.9211 0.944713C63.8997 0.959027 63.871 0.973341 63.8424 0.987654C63.4273 1.41707 63.3915 2.52639 63.3915 2.5407C62.4969 4.0866 61.1371 6.44838 60.6361 7.30721",
    fill: "#FC5B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30721C60.4715 7.20701 60.2783 7.15692 60.0779 7.15692V0C60.8723 0 61.6596 0.114511 62.4325 0.343532C62.4325 0.365003 62.4182 0.39363 62.4182 0.415101C62.3705 0.701378 62.4397 1.8608 62.6257 3.89336C61.8528 5.23171 61.0154 6.6774 60.6504 7.31437",
    fill: "#F95A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30721C60.4715 7.20701 60.2783 7.15692 60.0779 7.15692V0C60.45 0 60.8294 0.0286277 61.2015 0.0787261C61.2015 0.100197 61.2158 0.135981 61.223 0.157452L62.182 4.63768C61.5451 5.73269 60.9367 6.79191 60.6361 7.31437",
    fill: "#F65937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30721C60.4715 7.20701 60.2783 7.15692 60.0779 7.15692V0C60.0779 0 60.1351 0.0500984 60.1638 0.0715692C60.8723 1.25246 61.8743 5.13867 61.8814 5.16729C61.3661 6.06191 60.9009 6.87064 60.6504 7.30005",
    fill: "#F45836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30719C60.4715 7.20699 60.2783 7.15689 60.0779 7.15689V1.50293C60.0994 1.54587 60.128 1.61028 60.1495 1.65322C60.5932 2.46911 61.3089 4.44442 61.6309 5.58953C61.2087 6.31238 60.8437 6.94934 60.6361 7.31435",
    fill: "#F15736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30758C60.4715 7.20738 60.2783 7.15728 60.0779 7.15728V2.62695C60.1137 2.69137 60.1638 2.78441 60.1996 2.84882C60.5431 3.53588 61.0083 4.48059 61.4377 5.91913C61.1013 6.49884 60.815 6.99983 60.6361 7.30042",
    fill: "#EE5635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30713C60.4715 7.20693 60.2783 7.15684 60.0779 7.15684V3.46387C60.1137 3.52112 60.1566 3.59269 60.1924 3.64995C60.9582 5.13143 61.223 5.9831 61.2802 6.20497C61.0154 6.66301 60.7936 7.04948 60.6433 7.30713Z",
    fill: "#EB5535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30722C60.4715 7.20702 60.2783 7.15692 60.0779 7.15692V4.11523C60.0994 4.15818 60.1351 4.20827 60.1638 4.25122C60.5288 4.8023 61.0369 6.10486 61.1443 6.44123C60.9367 6.79908 60.7649 7.09251 60.6433 7.30722Z",
    fill: "#E85434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30724C60.4715 7.20704 60.2783 7.15694 60.0779 7.15694V4.65918C60.0779 4.65918 60.0922 4.68781 60.1065 4.70212C60.3928 5.12438 60.815 6.05478 61.0226 6.65596C60.8723 6.92076 60.7435 7.14263 60.6433 7.30724Z",
    fill: "#E55333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30655C60.4715 7.20635 60.2783 7.15625 60.0779 7.15625V5.10938C60.586 5.90379 60.8795 6.74115 60.9152 6.83419C60.8079 7.02027 60.7148 7.17772 60.6433 7.29939",
    fill: "#E25233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30679C60.4715 7.2066 60.2783 7.1565 60.0779 7.1565V5.49609C60.0779 5.49609 60.0994 5.53188 60.1137 5.54619C60.3427 5.88257 60.6361 6.51238 60.8222 6.99189C60.7578 7.1064 60.6934 7.21375 60.6433 7.29964",
    fill: "#E05132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30733C60.4715 7.20714 60.2783 7.15704 60.0779 7.15704V5.83301C60.357 6.25527 60.5073 6.60596 60.7363 7.13557C60.7005 7.19998 60.6719 7.25008 60.6361 7.30733",
    fill: "#DD5031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6433 7.30752C60.4715 7.20733 60.2783 7.15723 60.0779 7.15723V6.13379C60.0779 6.13379 60.1137 6.18389 60.128 6.21252C60.2139 6.35565 60.3928 6.70634 60.6648 7.26458C60.6648 7.26458 60.6433 7.29321 60.6361 7.30752",
    fill: "#DA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15707V6.39844C60.0779 6.39844 60.1065 6.44138 60.1208 6.46285C60.1972 6.58213 60.3403 6.84932 60.5502 7.26442C60.3999 7.19286 60.2425 7.16423 60.0779 7.16423",
    fill: "#D74E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15656V6.62695C60.1924 6.79156 60.2783 6.94186 60.4143 7.20666C60.3069 7.17088 60.1924 7.15656 60.0779 7.15656Z",
    fill: "#D44D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15702V6.83496C60.0779 6.83496 60.0994 6.87075 60.1137 6.88506C60.1781 6.9781 60.2353 7.0783 60.2926 7.17849C60.221 7.16418 60.1495 7.15702 60.0779 7.15702Z",
    fill: "#D14C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0779 7.15681V7.01367C60.0779 7.01367 60.0994 7.0423 60.1065 7.05661C60.128 7.0924 60.1566 7.12103 60.1781 7.15681C60.1423 7.15681 60.1137 7.15681 60.0779 7.15681Z",
    fill: "#CE4A2E"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.327 103.424H4.67371C2.09263 103.424 0.000244141 105.516 0.000244141 108.097V126.741C0.000244141 129.322 2.09263 131.415 4.67371 131.415H115.327C117.908 131.415 120 129.322 120 126.741V108.097C120 105.516 117.908 103.424 115.327 103.424Z",
    fill: "#192227"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3969 121.931L30.2167 125.881L24.1548 122.632L24.1763 120.206L27.3969 121.931Z",
    fill: "#BC934E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1763 120.206L24.1548 122.632L18.0356 125.788L20.9199 121.881L24.1763 120.206Z",
    fill: "#CEA256"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8027 118.324L29.1073 119.097L30.2166 125.882L27.3968 121.931L26.8027 118.324Z",
    fill: "#F8C267"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 121.881L18.0356 125.789L19.2523 119.018L21.564 118.288L20.9199 121.881Z",
    fill: "#C39951"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4508 115.791L34.0742 114.331L29.1073 119.098L26.8027 118.325L29.4508 115.791Z",
    fill: "#D7A95A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5641 118.288L19.2524 119.018L14.3643 114.173L18.9662 115.712L21.5641 118.288Z",
    fill: "#BB924E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8296 115.233L27.2681 113.286L34.0744 114.331L29.451 115.791L25.8296 115.233Z",
    fill: "#F3BF65"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9662 115.712L14.3643 114.173L21.1776 113.235L22.5876 115.211L18.9662 115.712Z",
    fill: "#EAB761"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5874 115.211L21.1775 113.235L24.2764 107.095L24.2335 111.94L22.5874 115.211Z",
    fill: "#C99E54"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2336 111.939L25.8295 115.232L29.4509 115.79L26.8029 118.323L27.3969 121.931L24.1763 120.206L20.9199 121.88L21.564 118.288L18.9661 115.711L22.5875 115.21L24.2336 111.939Z",
    fill: "#E9B761"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2336 111.94L24.2766 107.095L27.2682 113.285L25.8296 115.232L24.2336 111.94Z",
    fill: "#FDC669"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1814 121.938L66.0012 125.881L59.9321 122.632L59.9536 120.206L63.1814 121.938Z",
    fill: "#BC934E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9538 120.206L59.9323 122.632L53.8203 125.788L56.7046 121.881L59.9538 120.206Z",
    fill: "#CEA256"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5945 118.324L64.8919 119.097L66.0012 125.882L63.1813 121.938L62.5945 118.324Z",
    fill: "#F8C267"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7046 121.881L53.8203 125.789L55.037 119.018L57.3487 118.288L56.7046 121.881Z",
    fill: "#C39951"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2354 115.791L69.8516 114.331L64.8919 119.098L62.5945 118.325L65.2354 115.791Z",
    fill: "#D7A95A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3485 118.288L55.0369 119.018L50.1487 114.173L54.7506 115.712L57.3485 118.288Z",
    fill: "#BB924E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6143 115.233L63.0528 113.286L69.8519 114.331L65.2357 115.791L61.6143 115.233Z",
    fill: "#F3BF65"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7506 115.712L50.1487 114.173L56.9621 113.235L58.372 115.211L54.7506 115.712Z",
    fill: "#EAB761"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3721 115.211L56.9622 113.235L60.054 107.095L60.0182 111.947L58.3721 115.211Z",
    fill: "#C99E54"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0182 111.947L61.6142 115.232L65.2356 115.791L62.5947 118.324L63.1816 121.938L59.9538 120.206L56.7046 121.881L57.3487 118.288L54.7507 115.712L58.3721 115.211L60.0182 111.947Z",
    fill: "#E9B761"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0181 111.947L60.0539 107.095L63.0526 113.285L61.6141 115.232L60.0181 111.947Z",
    fill: "#FDC669"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.966 121.931L101.786 125.881L95.7239 122.632L95.7382 120.206L98.966 121.931Z",
    fill: "#BC934E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7381 120.206L95.7238 122.632L89.6118 125.788L92.4889 121.881L95.7381 120.206Z",
    fill: "#CEA256"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3718 118.324L100.676 119.097L101.786 125.882L98.9659 121.931L98.3718 118.324Z",
    fill: "#F8C267"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4889 121.881L89.6118 125.789L90.8213 119.018L93.133 118.288L92.4889 121.881Z",
    fill: "#C29951"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M101.02 115.791L105.643 114.331L100.676 119.098L98.3718 118.325L101.02 115.791Z",
    fill: "#D7A95A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1332 118.288L90.8215 119.018L85.9333 114.173L90.5352 115.712L93.1332 118.288Z",
    fill: "#BB924E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3987 115.233L98.8372 113.286L105.643 114.331L101.02 115.791L97.3987 115.233Z",
    fill: "#F3BF65"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5352 115.712L85.9333 114.173L92.7539 113.235L94.1638 115.211L90.5352 115.712Z",
    fill: "#EAB761"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1638 115.211L92.7539 113.235L95.8457 107.095L95.8099 111.947L94.1638 115.211Z",
    fill: "#C99E54"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8098 111.947L97.3986 115.232L101.02 115.791L98.372 118.324L98.966 121.931L95.7382 120.206L92.489 121.881L93.1331 118.288L90.5352 115.712L94.1637 115.211L95.8098 111.947Z",
    fill: "#E9B761"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8098 111.947L95.8456 107.095L98.8372 113.285L97.3987 115.232L95.8098 111.947Z",
    fill: "#FDC669"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3191_33573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0003 30C61.6248 30 63.1827 30.6453 64.3313 31.794C65.48 32.9426 66.1253 34.5005 66.1253 36.125C66.1253 37.7495 65.48 39.3074 64.3313 40.456C63.1827 41.6047 61.6248 42.25 60.0003 42.25C58.3759 42.25 56.8179 41.6047 55.6693 40.456C54.5206 39.3074 53.8753 37.7495 53.8753 36.125C53.8753 34.5005 54.5206 32.9426 55.6693 31.794C56.8179 30.6453 58.3759 30 60.0003 30ZM46.6675 45.7281C47.0284 44.3063 48.3081 43.125 49.9706 43.125C51.3159 43.125 52.4425 43.9125 53.0003 44.9844C54.3128 47.5219 56.9597 49.25 60.0003 49.25C63.0409 49.25 65.6878 47.5219 67.0003 44.9844C67.5581 43.9125 68.6847 43.125 70.03 43.125C71.7034 43.125 72.9831 44.3063 73.3331 45.7281C74.0987 48.7688 76.855 51.0109 80.1253 51.0109C81.3066 51.0109 82.4222 50.7156 83.3847 50.2016C84.3034 49.7203 85.4519 49.7094 86.4034 50.3C87.8253 51.175 88.2737 53.0344 87.4097 54.4563L75.7175 73.75H74.0003H69.5816H50.4191H46.0003H44.2831L32.5909 54.4563C31.7269 53.0344 32.1753 51.175 33.5972 50.3C34.5487 49.7203 35.6972 49.7203 36.6159 50.2016C37.5894 50.7156 38.6941 51.0109 39.8753 51.0109C43.1456 51.0109 45.9019 48.7688 46.6675 45.7281ZM44.2503 77.25H75.7503L80.2784 81.7781C80.7378 82.2375 81.0003 82.8719 81.0003 83.5281C81.0003 84.8953 79.8956 86 78.5284 86H41.4722C40.105 86 39.0003 84.8953 39.0003 83.5281C39.0003 82.8719 39.2628 82.2375 39.7222 81.7781L44.2503 77.25Z",
    fill: "#FFCABF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3191_33573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(32.0002 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertoTres);
export default __webpack_public_path__ + "static/media/expertoTres.902403725fd3c7f83105fdc410ff2fd0.svg";
export { ForwardRef as ReactComponent };